module.exports = __webpack_public_path__ + "media/beach.1dbea9f8.jpg";